import {
  CoachAvailabilityStatusesEnum,
  GetCoachesBySportAndGeoQuery,
} from 'types/generated/client';

export type RawCoach = GetCoachesBySportAndGeoQuery['userProfiles'][number];

export const hasProfilePhoto = (coach: RawCoach) => Boolean(coach.profileImageProviderUrl);

export function calculateCoachScore(coach: RawCoach): number {
  const reviewCount = coach.coachReviewsAggregate?.aggregate?.count || 0;
  const avgRating = (coach.coachReviewsAggregate?.aggregate?.avg?.rating as number) || 0;
  const lessonCount = coach.coachLessonsAggregate?.aggregate?.count || 0;

  const isInstantBook =
    Boolean(coach.stripeMerchantChargesEnabled) &&
    Boolean(
      coach.coachAvailability?.some((a) => a.status === CoachAvailabilityStatusesEnum.Active),
    );

  const reviewScore = (avgRating / 5) * Math.min(reviewCount / 10, 1);
  const lessonScore = Math.min(lessonCount / 100, 1);
  const instantBookScore = isInstantBook ? 1 : 0;

  return reviewScore * 0.5 + lessonScore * 0.3 + instantBookScore * 0.2;
}
